window.jQuery = require('jquery');
window.$ = window.jQuery;
require('bootstrap');
require('bootstrap-select');
require('jscroll');
require("pc-bootstrap4-datetimepicker");
require('owl.carousel');
require('jquery-ui/ui/widgets/sortable');
require('tolnaiz-jcrop');
import _ from 'lodash';
require("@fancyapps/fancybox");
require('ion-rangeslider');
var L = require('leaflet');
var L = require('./leaflet.numbered.divicon')(L);
require('leaflet.markercluster');
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconAnchor: [8,37],
    popupAnchor: [5, -30]
});

var greenIcon = new L.Icon({
  iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import allLocales from '@fullcalendar/core/locales-all';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';


L.Marker.prototype.options.icon = DefaultIcon;

var axios = require('axios');
import Vue from 'vue';
import Autocomplete from '@trevoreyre/autocomplete-vue';
Vue.use(Autocomplete);
import draggable from 'vuedraggable';
const moment = require('moment');
require('moment/locale/hu');
Vue.use(require('vue-moment'), {
    moment
});

axios.defaults.headers.common['Authorization'] = "5b3ce3597851110001cf6248add7e378d248456b8e675bdb01ed75e1";

require("./turatervezo.js");

//túra kereső térkép nézet
$("#terkep-info").hide();

var map;

var map_to_tura;

var latnivalo_kereso_map;

var tura_utvonal_layer = L.layerGroup([]);

var tura_kezdopont_layer = L.markerClusterGroup();

var customMarker = L.Marker.extend({
    options: {
        clicked: 0,
        id: ''
    }
});

var kivansaglista = {};

var lakhely_layer = L.layerGroup([]);

if ($('section.tura-kereso').length>0) {
    var turakereso = new Vue({
        el: 'section.tura-kereso',
        components: {
        Autocomplete
        },
        data: {
            kereso: '',
            latnivalo: false,
            rendezveny: false,
            kategoria: 'nincs',
            elevation: $(".js-range-slider-emelkedes")[0].value.split(';'),
            distance: $(".js-range-slider-tavolsag")[0].value.split(';'),
            duration: $(".js-range-slider-idotartam")[0].value.split(';'),
            top_ertekelt: '',
            tomegkozlekedes: '',
            kortura: '',
            szep_kilatas: '',
            piheno: '',
            csaladi: '',
            felszereles_szukseges: '',
            nehezsegi_szint_id: 'osszes',
            alkategoria_id: 'osszes',
            kategoria_turak: [],
            turak: [],
            tura: [],
            locale: $('input[type="hidden"][name="locale"]').val(),

        },
        methods: {
            throttledSearch: _.throttle(function() {
                this.search();
            }, 500),
            search() {
                axios.post('/tura/kereso',{
                    kereso: this.kereso,
                    latnivalo: this.latnivalo,
                    rendezveny: this.rendezveny,
                    kategoria: this.kategoria,
                    top_ertekelt: this.top_ertekelt,
                    frissitopont: this.frissitopont,
                    nehezsegi_szint_id: this.nehezsegi_szint_id,
                    alkategoria_id: this.alkategoria_id,
                    bovebb: {
                        tomegkozlekedes: this.tomegkozlekedes,
                        kortura: this.kortura,
                        szep_kilatas: this.szep_kilatas,
                        piheno: this.piheno,
                        csaladi: this.csaladi,
                        felszereles_szukseges: this.felszereles_szukseges,
                    },
                    elevation: $(".js-range-slider-emelkedes")[0].value.split(';'),
                    distance: $(".js-range-slider-tavolsag")[0].value.split(';'),
                    duration: $(".js-range-slider-idotartam")[0].value.split(';'),
                    locale: this.locale,
                  }).then((response) => {
                      this.turak = response.data;
                      this.kategoria_turak = response.data;

                      if(map.hasLayer(tura_utvonal_layer)) {
                        tura_utvonal_layer.eachLayer(function (layer) {
                            tura_utvonal_layer.removeLayer(layer);
                        });
                      }

                      if(map.hasLayer(tura_kezdopont_layer)) {
                        tura_kezdopont_layer.eachLayer(function (layer) {
                            tura_kezdopont_layer.removeLayer(layer);
                        });
                      }

                       this.display_all();
                  });
            },
            display_all() {
                for(var key in this.turak) {
                    var tura = this.turak[key];
                    this.display(tura);
                }

                map.addLayer(tura_kezdopont_layer);
            },
            display: function(tura) {
                if(tura != undefined) {
                    if (tura.trackpoints.length > 1 || tura.waypoints.length > 1 || tura.routepoints.length > 1) {

                        if(tura.trackpoints.length > 1) {
                            
                            var tura_koordinatak = JSON.parse(JSON.stringify(tura.trackpoints));

                            var coordinates = tura_koordinatak;

                            var marker = new customMarker([coordinates[0][0], coordinates[0][1]], {clicked: 0, id: tura.id});

                            marker.addTo(tura_kezdopont_layer).bindPopup("<a class=\"btn btn-primary\" href=\"/tura/"+tura.id+"/adatlap\">Túra adatlapja</a>")
                            .on('click', function (e) {
                                
                                if(e.target.options.clicked == 0) {
                                    if(map.hasLayer(tura_kezdopont_layer)) {
                                        tura_kezdopont_layer.eachLayer(function(layer) {
                                            layer.options.clicked = 0;
                                        });
                                    }

                                    e.target.options.clicked = 1;

                                    if(map.hasLayer(tura_utvonal_layer)) {
                                        map.removeLayer(tura_utvonal_layer);
    
                                        tura_utvonal_layer.eachLayer(function(layer){
                                            tura_utvonal_layer.removeLayer(layer);
                                        });
                                    }

                                    var polyline = L.polyline(coordinates, {color: tura.color});
                                    map.fitBounds(polyline.getBounds());
                                    tura_utvonal_layer.addLayer(polyline);
                                    map.addLayer(tura_utvonal_layer);
    
                                    if(tura.waypoints.length > 1) {
                                        var waypoints = JSON.parse(JSON.stringify(tura.waypoints));
                                        for (var key in waypoints) {
                                            var key2 = waypoints[key];
                                            var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                                            var marker = L.marker([coordinates[key2][0], coordinates[key2][1]],
                                                {
                                                    icon: myIcon
                                                }
                                            ).addTo(map);
                                        }
                                    }
                             
                                }
                                else {
                                    e.target.options.clicked = 0;
                                    if(map.hasLayer(tura_utvonal_layer)) {
                                        map.removeLayer(tura_utvonal_layer);
                                        tura_utvonal_layer.eachLayer(function(layer){
                                            tura_utvonal_layer.removeLayer(layer);
                                        });
                                    }
                                }

                                //map.fitBounds(polyline.getBounds());
        
                            });

                            //map.addLayer(tura_kezdopont_layer);
                            
                        }
                        else if(tura.waypoints.length > 1) {
                            var tura_koordinatak = JSON.parse(JSON.stringify(tura.waypoints));

                            axios.post('https://api.openrouteservice.org/v2/directions/'+tura.kategoria.api_nev+'/geojson', {
                            coordinates: tura_koordinatak,
                            elevation: true,
                            instructions: true,
                            language: 'en-US',
                            preference: 'fastest'
                        }).then(function (response) {
                            //console.log(response.data.features);

                            var coordinates = response.data.features[0].geometry.coordinates.map(x => [x[1], x[0]]);

                            var polyline = L.polyline(coordinates, {color: tura.color}).addTo(map);
                            map.fitBounds(polyline.getBounds());
                            var waypoints = response.data.features[0].properties.way_points;
                            for (var key in waypoints) {
                                var key2 = waypoints[key];
                                var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                                var marker = L.marker([coordinates[key2][0], coordinates[key2][1]],
                                    {
                                        icon: myIcon
                                    }
                                    ).addTo(map);
                                }
                            })

                        }
                    }
                }
            },
            trigger: function (tura) {
                if(map.hasLayer(tura_kezdopont_layer)) {
                    tura_kezdopont_layer.eachLayer(function(layer) {
                        if(layer.options.id == tura.id) {
                            layer.fire('click');
                        }
                    });
                }
            },
            mouseOver: function(tura) {
                tura.color = '#FF0000';
                this.display(tura);
            },
            mouseLeave: function(tura) {
                tura.color = '#0C59D0';
                this.display(tura);
            }
        },
        computed: {
            filteredTurak() {
                /*if(this.kereso == '') {
                    return this.turak;
                }
                else {
                    return this.turak.filter(tura => {
                        return tura.nev.toLowerCase().includes(this.kereso.toLowerCase());
                    });
                }*/

                return this.turak;
            }
        },
        watch: {
            kereso: function () {
                if(this.kereso.length >= 3) {
                    this.throttledSearch();
                }
                else if(this.kereso == '') {
                    this.throttledSearch();
                }
            }
        },
    });
}

var latnivalo_kereso = new Vue({
    el: '#latnivalo_kereso_map',
    methods: {
        display_all: function(latnivalok) {
            var group = L.markerClusterGroup();

            for(var key in latnivalok) {
                var latnivalo = latnivalok[key];
                group.addLayer(L.marker([latnivalo.lat, latnivalo.lng]).bindPopup(latnivalo.nev + '<br>' + '<a href="/latnivalok/' + latnivalo.id + '/adatlap">Tovább az adatlapra</a>'));
                //this.display(latnivalo, latnivalo_kereso_map);
            }
            group.addTo(latnivalo_kereso_map);
        }
    }
});

$('.bs-select').selectpicker({
    noneSelectedText: '(válasszon)',
    liveSearch: true,
    liveSearchPlaceholder: '(keresés)'
});

var tura_single;

$(document).ready(function() {
    //RangeSlider value
    // var slider = document.getElementById("myRange");
    // var output = document.getElementById("myRangeValue");
    // output.innerHTML = slider.value; // Display the default slider value

    // slider.oninput = function() {
    //     output.innerHTML = this.value;
    // }

    if(document.getElementById('dropzone_watch')) {

        $('#dropzone_watch')[0].dropzone.options.addRemoveLinks = true;

        $('#dropzone_watch')[0].dropzone.on('success', function(file) {
            var args = Array.prototype.slice.call(arguments);
            file._removeLink.href = args[1].remove_url;
        });

        $('#dropzone_watch')[0].dropzone.on('removedfile', function(file) {
            $.ajax({
                url: file._removeLink.href,
                type: 'DELETE',
            })
            .done(function() {
                console.log("succes");
            })
            .fail(function() {
                console.log("error");
            })
            .always(function() {
                console.log("complete");
            });
        });

        $('#dropzone_watch')[0].dropzone.on('addedfile', function(file) {
            galeria_db += $('#dropzone_watch')[0].dropzone.files.length;
        });
    }

    jQuery('.custom-file-input').on('change', function() {
        let fileName = jQuery(this).val().split('\\').pop();
        jQuery(this).next('.custom-file-label').addClass("selected").html(fileName);
    });

    $('.map_egy_tura').each(function(index, el) {
        var map = L.map(el.id, {gestureHandling: true}).setView([47.6,17.7], 10);
        var tl = L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18,
        }).addTo(map);

        kozeli_latnivalok.forEach(function(el, index) {
            L.marker([parseFloat(el.lat), parseFloat(el.lng)]).bindPopup(el.nev + '<br>' + '<a href="/latnivalok/' + el.id + '/adatlap">Tovább az adatlapra</a>').addTo(map);
        });

        // tl.on("load",function() { console.log("all visible tiles have been loaded") });
        var tura = $(this).data('tura');
        if (typeof tura != undefined && (tura.trackpoints.length > 1 || tura.waypoints.length > 1 || tura.routepoints.length > 1)) {
            if(tura.trackpoints.length > 1) {

                var tura_koordinatak = JSON.parse(JSON.stringify(tura.trackpoints));

                var coordinates = tura_koordinatak;
                var polyline = L.polyline(coordinates, {color: '#0C59D0'}).addTo(map);
                map.fitBounds(polyline.getBounds());

                if(tura.waypoints.length > 1) {
                    var waypoints = JSON.parse(JSON.stringify(tura.waypoints));
                    for (var key in waypoints) {
                        var key2 = waypoints[key];
                        var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                    }
                }
            }
            else if(tura.waypoints.length > 1) {
                var tura_koordinatak = JSON.parse(JSON.stringify(tura.waypoints));

                axios.post('https://api.openrouteservice.org/v2/directions/'+tura.kategoria.api_nev+'/geojson', {
                    coordinates: tura_koordinatak,
                    elevation: true,
                    instructions: true,
                    language: 'en-US',
                    preference: 'fastest'
                }).then(function (response) {
                //console.log(response.data.features);

                var coordinates = response.data.features[0].geometry.coordinates.map(x => [x[1], x[0]]);

                var polyline = L.polyline(coordinates, {color: '#0C59D0'}).addTo(map);
                map.fitBounds(polyline.getBounds());
                var waypoints = response.data.features[0].properties.way_points;
                for (var key in waypoints) {
                    var key2 = waypoints[key];
                    var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                    }
                })

            }
        }
    });

    // if (document.getElementById("map_single")) {
    //     var map_erdeklodes = new Vue({
    //         el: '#map_single',
    //         components: {
    //         Autocomplete
    //         },
    //         data: {
    //             point: [],
    //         },
    //         methods: {
    //             post_data() {
    //                 axios.post('/profil/beallitasok/koordinatak', {
    //                     point: this.point,
    //                 });
    //             }
    //         }
    //     });
    // }


    if (document.getElementById("map_latnivalo")) {
        var map_latnivalo = L.map('map_latnivalo', {gestureHandling: true}).setView([$('#map_latnivalo').data('lat'),$('#map_latnivalo').data('lng')], 14);
        L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        maxZoom: 18,
        }).addTo(map_latnivalo);
        L.marker([$('#map_latnivalo').data('lat'), $('#map_latnivalo').data('lng')], {icon: greenIcon}).addTo(map_latnivalo);
        var poik;
        if (poik = $('#map_latnivalo').data('poik')) {
            poik.forEach(function(el, index) {
                L.marker([parseFloat(el.lat), parseFloat(el.lng)], {icon: DefaultIcon}).bindPopup(el.nev + '<br>' + '<a href="/latnivalok/' + el.id + '/adatlap">Tovább az adatlapra</a>').addTo(map_latnivalo);
            });
        }
    }

    if (turakereso) {
        if(document.getElementById("map-terkep-lista")) {
            var map_1 = L.map('map-terkep-lista', {gestureHandling: true}).setView([47.6,17.7], 10);
            L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18,
            }).addTo(map_1);

            map = map_1;
        }

        if(document.getElementById("map-kereso")) {
            var map_2 = L.map('map-kereso', {gestureHandling: true}).setView([47.6,17.7], 10);
            L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18,
            }).addTo(map_2);
        }

        $('#maplist-tab').on('click', function () {
            tura_kezdopont_layer.eachLayer(function (layer) {
                tura_kezdopont_layer.removeLayer(layer);
            });

            tura_utvonal_layer.eachLayer(function (layer) {
                tura_utvonal_layer.removeLayer(layer);
            });

            if(map.hasLayer(tura_kezdopont_layer)) {
                map.removeLayer(tura_kezdopont_layer);
            }

            if(map.hasLayer(tura_utvonal_layer)) {
                map.removeLayer(tura_utvonal_layer);
            }

            map = map_1;

            turakereso.throttledSearch();

            setInterval(function ()  {
                map.invalidateSize();
            }, 100);
        });

        $('#terkep-tab').on('click', function () {
            tura_kezdopont_layer.eachLayer(function (layer) {
                tura_kezdopont_layer.removeLayer(layer);
            });

            tura_utvonal_layer.eachLayer(function (layer) {
                tura_utvonal_layer.removeLayer(layer);
            });
            
            if(map.hasLayer(tura_kezdopont_layer)) {
                map.removeLayer(tura_kezdopont_layer);
            }

            if(map.hasLayer(tura_utvonal_layer)) {
                map.removeLayer(tura_utvonal_layer);
            }

            map = map_2;

            turakereso.throttledSearch();

            setInterval(function ()  {
                map.invalidateSize();
            }, 100);
        });
    }

    if(latnivalo_kereso) {
        if(document.getElementById("latnivalo_map_list")) {
            var latnivalo_kereso_map_1 = L.map('latnivalo_map_list', {gestureHandling: true}).setView([47.6,17.7], 11);
            L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18,
            }).addTo(latnivalo_kereso_map_1);

            latnivalo_kereso_map = latnivalo_kereso_map_1;

            latnivalo_kereso.display_all(latnivalok);

            setInterval(function ()  {
                latnivalo_kereso_map.invalidateSize();
            }, 100);
        }

        if(document.getElementById("latnivalo_map")) {
            var latnivalo_kereso_map_2 = L.map('latnivalo_map', {gestureHandling: true}).setView([47.6,17.7], 11);
            L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18,
            }).addTo(latnivalo_kereso_map_2);
        }

        $('#latnivalok-maplist-tab').on('click', function () {
            latnivalo_kereso_map = latnivalo_kereso_map_1;

            latnivalo_kereso.display_all(latnivalok);
        });

        $('#latnivalok-terkep-tab').on('click', function () {
            latnivalo_kereso_map = latnivalo_kereso_map_2;

            latnivalo_kereso.display_all(latnivalok);
        });

        

    }

    if (document.getElementById("map_to_tura")) {

        $('.nav-tabs a').on('shown.bs.tab ', function () {
          if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(displayLocationInfo);
          }

          function displayLocationInfo(position) {
              const lng = position.coords.longitude;
              const lat = position.coords.latitude;

              map_to_tura = L.map('map_to_tura', {gestureHandling: true}).setView([47.6,17.7], 10);
              L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                  attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
                  maxZoom: 18,
              }).addTo(map_to_tura);
              if ($(".map_egy_tura").length) {
                var tura = $(".map_egy_tura").data('tura');
                console.log(tura);
                var first_point = tura.trackpoints.length>0 ? tura.trackpoints[0] : tura.waypoints[0];
                var tura_koordinatak = [first_point.reverse(), [lng, lat]];
                var tipus = 'driving-car';
              }else{

                var tura_koordinatak = [[$('#map_latnivalo').data('lng'),$('#map_latnivalo').data('lat')], [lng, lat]];
                var tipus = 'driving-car';
              }

              axios.post('https://api.openrouteservice.org/v2/directions/'+tipus+'/geojson', {
                  coordinates: tura_koordinatak,
                  elevation: true,
                  instructions: true,
                  language: 'en-US',
                  preference: 'fastest'
                  }).then(function (response) {
                      //console.log(response.data.features);

                      var coordinates = response.data.features[0].geometry.coordinates.map(x => [x[1], x[0]]);

                      var polyline = L.polyline(coordinates, {color: '#FF0000'}).addTo(map_to_tura);
                      map_to_tura.fitBounds(polyline.getBounds());
                      var waypoints = response.data.features[0].properties.way_points;
                      for (var key in waypoints) {
                          var key2 = waypoints[key];
                          var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                          var marker = L.marker([coordinates[key2][0], coordinates[key2][1]],
                              {
                                  icon: myIcon
                              }
                              ).addTo(map_to_tura);

                      }
                  });

              // tura_single.map_to_tura(lng, lat);

          }
        });
    }

    if(document.getElementById("map_erdeklodes")) {


        if(!(parseFloat(koordinatak[0]) == 0 && parseFloat(koordinatak[1]) == 0)) {
            map = L.map('map_erdeklodes', {gestureHandling: true}).setView([parseFloat(koordinatak[0]),parseFloat(koordinatak[1])], 10);

            var marker = L.marker([parseFloat(koordinatak[0]), parseFloat(koordinatak[1])]);
            lakhely_layer.addLayer(marker);
            map.addLayer(lakhely_layer);
        }
        else {
            map = L.map('map_erdeklodes', {gestureHandling: true}).setView([47.7,17.6], 10);
        }

        map.on("click", function(e) {
            map_erdeklodes.point = [e.latlng.lat, e.latlng.lng];

            if(map.hasLayer(lakhely_layer)) {
                map.removeLayer(lakhely_layer);
            }
            lakhely_layer.eachLayer(function(layer){
                lakhely_layer.removeLayer(layer);
            });

            var marker = L.marker(map_erdeklodes.point);
            lakhely_layer.addLayer(marker);
            map.addLayer(lakhely_layer);

            map_erdeklodes.post_data();

            console.log(map_erdeklodes.point);
        });
        L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18,
        }).addTo(map);
    }

    //Érdeklődés modal
    $('#erdeklodesModal').modal('show');

    // L.vectorGrid.protobuf("http://a.tiles.mapbox.com/v4/mapbox.outdoors/{zoom}/{x}/{y}.mvt?access_token={key}", {
    //     key: 'pk.eyJ1IjoidG9sbmFpeiIsImEiOiJjajVqdnJxdTIyaG45MzJvZGg5N3JjeWk3In0.npvpLSXfhsmCy0xFOrjxHA',
    //     maxNativeZoom: 14,
    //     zoom: 14
    // }).addTo(map);

    $(".js-range-slider-emelkedes").ionRangeSlider({
        type: "double",
        min: 0,
        max: 1500,
        from: 0,
        to: 4500,
        grid: true
    });

    $(".js-range-slider-tavolsag").ionRangeSlider({
        type: "double",
        min: 0,
        max: max_tavolsag_slider,
        from: 0,
        to: max_tavolsag_slider,
        grid: true
    });

    $(".js-range-slider-idotartam").ionRangeSlider({
        type: "double",
        min: 0,
        max: 30,
        from: 0,
        to: 30,
        grid: true
    });

    if (turakereso) {
        $(".js-range-slider-emelkedes").on('change', function() {
            turakereso.throttledSearch();
        });

        $(".js-range-slider-tavolsag").on('change', function() {
            turakereso.throttledSearch();
        });

        $(".js-range-slider-idotartam").on('change', function() {
            turakereso.throttledSearch();
        });
    }

    //Rendezvények datepicker
    $('.datepicker, #datepicker').datetimepicker({
        // language: $("html").attr("lang"),
        // todayHighlight: true,

        format: 'YYYY-MM-DD',
        // weekStart: 1,
    });

    $('.datetimepicker').datetimepicker({
        format: 'YYYY-MM-DD HH:mm',
        locale: $('html').attr('lang')
    });

    jQuery(document).on('click', '.confirm', function() {
        return confirm('Biztos benne?');
    });

    //NavFixed Transform
    // $(document).scroll(function() {
    //     if ($(document).scrollTop() >= 1) {
    //         $('.navbar-brand img').css('width', '75%');
    //         $('.navbar-brand').css('padding', '.5rem 0');
    //         $('.navbar.upper').css('display', 'none');
    //         $('#header').css('box-shadow', '0 0 20px 0 #aaa');
    //         $('.navbar-toggler').css('margin-top', '1rem');
    //     }
    //     else{
    //         $('.navbar-brand img').css('width', '100%');
    //         $('.navbar-brand').css('padding', '2rem 0');
    //         $('.navbar.upper').css('display', 'block');
    //         $('#header').css('box-shadow', '0 0 0 0');
    //         $('.navbar-toggler').css('margin-top', '4rem');
    //     }
    // });

    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:5
            }
        }
    })
    $('.owl-next span').html("<i class='fas fa-arrow-circle-right'></i>");
    $('.owl-prev span').html("<i class='fas fa-arrow-circle-left'></i>");

    //searchbar empty
    $('#tura-ajanlo-searchbar').on('input', function() {
        if($('#tura-ajanlo-searchbar').val().length > 3){
            $.ajax({
                url: '/tura-ajanlo-kereso',
                type: 'POST',
                dataType: 'json',
                data: {input: $('#tura-ajanlo-searchbar').val()},
            })
            .done(function(data) {
                $('#tura-ajanlo-dropdown').empty();
                $.each(data, function (key, val) {
                  $("<a/>").attr("href", val.url).text(val.nev).appendTo("#tura-ajanlo-dropdown");
                });

                $('#tura-ajanlo-dropdown').css("display", "block");
            })
            .fail(function() {
                console.log("error");
            })
            .always(function() {
                console.log("complete");
            });

        }
        else{
            $('#tura-ajanlo-dropdown').css("display", "none");
        }
    });

    $('.tura_kedveles').on('click', function (e) {
        $.ajax({
            url: '/tura/' + e.target.getAttribute('id') + '/kedvelesAjax',
            type: 'POST',
            dataType: 'json',
            data: {id: e.target.getAttribute('id')},
        })
        .done(function() {
            console.log("succes");
        })
        .fail(function() {
            console.log("error");
        })
        .always(function() {
            location.reload();
            console.log("complete");
        });
    });

    jQuery.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
        }
    });
    jQuery(document).on('click', '.torol', function(e) {
        e.preventDefault();
        if (confirm('Biztos benne?')) {
            var jQuerythis = jQuery(this);
            jQuery.ajax({
                url: jQuerythis.attr('href'),
                method: 'DELETE',
                success: function(resp) {
                    jQuery('#item_' + resp.id).remove();
                    if($('#dropzone_watch')[0].dropzone) {
                        galeria_db--;
                    }
                },
                error: function() {
                    alert('Hiba történt');
                }
            });
        }
    });

    $('#sajat_mentes').on('click', function() {
        if(galeria_db == 0) {
            alert('Galéria feltöltése kötelező!');
            return false;
        }
    });

    
});

jQuery.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
    }
});
jQuery(document).on('click', '.torol', function(e) {
    e.preventDefault();
    if (confirm('Biztos benne?')) {
        var jQuerythis = jQuery(this);
        jQuery.ajax({
            url: jQuerythis.attr('href'),
            method: 'DELETE',
            success: function(resp) {
                jQuery('#item_' + resp.id).remove();
                if($('#dropzone_watch')[0].dropzone) {
                    galeria_db--;
                }
            },
            error: function() {
                alert('Hiba történt');
            }
        });
    }
});
jQuery(document).on('click', '.ajandek', function(e) {
    e.preventDefault();
    if (confirm('Biztos benne?')) {
        var jQuerythis = jQuery(this);
        jQuery.ajax({
            url: jQuerythis.attr('href'),
            method: 'POST',
            success: function(resp) {
                if(resp == 'error') {
                    alert('Sajnos ehhez az ajándékhoz nincs elegendő Cultractive pontja.');
                }
                else if(resp == 'success') {
                    location.reload();
                }
            },
            error: function() {
                alert('Hiba történt');
            }
        });
    }
});
function rendezheto() {
    jQuery('.rendezheto').sortable({
        update: function (event, ui) {
            var jQuerythis = jQuery(this);
            console.log(jQuerythis.data('action'));
            jQuery.post(jQuerythis.data('action'), {
                data: jQuerythis.sortable('serialize')
            });
        }
    });
}
rendezheto();

$('.szervezett_tura_nem_jovahagyott').on('click', function (e) {
    e.preventDefault();
    alert('Ez a szervezett túra még nincs jóváhagyva!');
});

var jcrop_promises = [];
    jQuery('.jcrop').each(function() {
        var jQuerythis = jQuery(this),
            name = jQuerythis.data('name') || '_kivagasok',
            aspectRatio = jQuerythis.data('aspect-ratio') || 1,
            selection = jQuerythis.data('selection'),
            jQueryinput = jQuery('<input type="hidden" name="' + name + '[' + aspectRatio + ']">');

        jQuerythis.parent().append(jQueryinput);
        var p = new Promise(function(resolve, reject) {
            setTimeout(function() { // hack!
                if(!selection || typeof selection != 'object'){
                    selection = {'x': 0, 'y': 0, 'x2': 0, 'y2':0};
                }

                jQuerythis.Jcrop({
                    trueSize: [
                        jQuerythis.get(0).naturalWidth,
                        jQuerythis.get(0).naturalHeight
                    ],
                    keySupport: false,
                    aspectRatio: aspectRatio,
                    onChange: function(c) {
                        jQueryinput.val(JSON.stringify(c));
                    },
                    onSelect: function(c) {
                        jQueryinput.val(JSON.stringify(c));
                    },
                    setSelect: [
                        selection.x,
                        selection.y,
                        selection.x2,
                        selection.y2
                    ],
                    boxWidth: jQuerythis.width() || 900, // hack 2!
                    bgColor: 'black'
                });
                resolve();
            }, 400);
        });
        jcrop_promises.push(p);
    });

//Rendezvények datepicker
$('.datepicker, #datepicker').datetimepicker({
    // language: $("html").attr("lang"),
    // todayHighlight: true,

    format: 'YYYY-MM-DD',
    // weekStart: 1,
});

$('.datetimepicker').datetimepicker({
    format: 'YYYY-MM-DD HH:mm',
    locale: $('html').attr('lang')
});

// rendezvények betöltése
$(".button").click(function(){
    $(".rendezveny").css("display", "block");
});

// jumpTop
$(".jumpTop").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
});

if(document.getElementById('naptar')) {
    var calendarEl = document.getElementById('naptar');

    var calendar = new Calendar(calendarEl, {
        plugins: [ dayGridPlugin ],
        locales: allLocales,
        locale: $('html').attr('lang'),
        eventColor: '#3490dc',
        eventTextColor: 'white',
        eventTimeFormat: {
            hour: 'numeric',
            minute: '2-digit',
            meridiem: false
        },
        eventClick: function (info) {
            window.location = info.event.url;
        },
        events: naptar_esemenyek
    });

    calendar.render();
}

//Active Nav
var url = window.location.pathname.replace('/en', '').replace('/sk', '');
var stripped_url = url.slice(1);
var hrefs = document.getElementsByClassName('nav-link');

for(var i = 0; i < hrefs.length; i++){
    var stripped_href = hrefs[i].href.replace('/en', '').replace('/sk', '').split(".hu/")[1];

    if(stripped_url.length > 0 && stripped_href == stripped_url && (stripped_url == 'tura/ajanlo' || stripped_url == 'tura/kereso' || stripped_url == 'tura/tervezo')) {

        $('.nav-item').removeClass('active');
        $('.turak').addClass('active');
        $('.' + stripped_href.replace('/', '-')).addClass('active').css('background-color', '#fff').css('color', '#97BF0D');
    }
    else if(stripped_url.length > 0 && stripped_href == stripped_url && stripped_href.indexOf('/') == -1){
        $('.nav-item').removeClass('active');
        $('.' + stripped_href).addClass('active');
    }
    else if(stripped_url.length == 0){
        $('.navbar .fooldal').addClass('active');
    }
}

/*
*** OLD SOLUTION ***
*
var bodyClass = $("body").attr('class');
if($(".nav-item").hasClass( bodyClass )){
    $('.nav-item').removeClass('active');
    $('.' + bodyClass).addClass('active');
}
*/

// Profile Active Nav
$(".profil-attekintes .col-2 a").on("click", function(){
    $(".profil-attekintes .col-2 a").removeClass("active");
    $(this).addClass("active");
});

//SearchBox Appear
$("#search-icon").on("click", function(){
    $("#search-bar").animate({opacity: "1", left: "0"});
});

//FancyBox
$().fancybox({
    selector : '.fancybox',
    thumbs   : {
        autoStart : true
    }
});

/*
//jScroll
$('ul.                                                                                                                                                                                                                                                                                                         nation').hide();
$(function() {
    $('.latnivalo-' +
        'ajanlo').jscroll({
        autoTrigger: true,
        loadingHtml: '<img class="center-block" src="/images/loading.gif" alt="Loading..." />', // MAKE SURE THAT YOU PUT THE CORRECT IMG PATH
        padding: 0,
        nextSelector: '.pagination li.active + li a',
        contentSelector: 'div.ajanlo-elem',
        callback: function() {
            $('ul.pagination').remove();
        }
    });
});
*/
$('ul.pagination').hide();
var options = {
    nextSelector: 'a.page-link:last',
    contentSelector: '.latnivalo-ajanlo',
    callback: function() {
        $('ul.pagination').remove();
    }
};

$('.latnivalo-ajanlo').jscroll(options);


// WEBPACK FOOTER //
// ./resources/js/app.js